export var FontFamily;
(function (FontFamily) {
  FontFamily["MAIN"] = "Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", sans-serif";
  FontFamily["MONO"] = "\"Roboto Mono\", monospace";
})(FontFamily || (FontFamily = {}));